const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = event => {
      // here I check that click was outside the el and his children
      if (
        !(
          !document.body.contains(event.target) ||
          el == event.target ||
          el.contains(event.target)
        ) &&
        event.which == 1
      ) {
        // and if it did, call method provided in attribute value
        binding.value && typeof binding.value === 'function' && binding.value()
      }
    }
    setTimeout(() => {
      document.addEventListener('mousedown', el.clickOutsideEvent)
    }, 1000)
  },
  unmounted: el => {
    document.removeEventListener('mousedown', el.clickOutsideEvent)
  },
}
export default clickOutside
